exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".verifyEmailComponent .logo[data-v-228d3378]{max-width:200px}\n", ""]);

